import { OrderType } from '@us/web/shared/data-access';
import { formatISO, roundToNearestMinutes } from 'date-fns';

export const BOOKING_TIME_MINUTE_STEP = 15;

export const getBookingTime = (orderType: OrderType | null) =>
    formatISO(
        orderType === OrderType.Delivery || orderType === null
            ? new Date()
            : roundToNearestMinutes(new Date(), { nearestTo: BOOKING_TIME_MINUTE_STEP })
    );
